import { render, staticRenderFns } from "./StatusCliente.vue?vue&type=template&id=1de9484f"
import script from "./StatusCliente.vue?vue&type=script&lang=js"
export * from "./StatusCliente.vue?vue&type=script&lang=js"
import style0 from "./StatusCliente.vue?vue&type=style&index=0&id=1de9484f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports